module.exports = __webpack_public_path__ + "img/電気回路_4_5_2.49ffb73e.png";